import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-react/wizard';

export const useSkipAdCreationState = () => {
  const { state: wizardState, send: wizardSend } = useWizardService();

  return [
    wizardState.context.wizardData.isSkipAdCreation,
    value => wizardSend(WIZARD_EVENTS.UPDATE_WIZARD_DATA, { isSkipAdCreation: value }),
  ];
};
